/**
 * Rechte Spalte im Kopfbereich: fasst in drei bis vier Punkten zusammen,
 * worum es auf der Seite geht. Gleiche Bildsprache wie die Karten auf
 * „Über uns“ und der Demo. `items`: { icon, title, text }.
 */
// Bewusst ohne farbigen Schein dahinter: Der hing an laufenden Animationen und
// war je nach Scrollstand mal sichtbar, mal nicht.
export const HeroCard = ({ kicker, items }) => (
  <div className="relative">
    <div className="rounded-[2rem] border border-white/10 backdrop-blur-xl p-7 md:p-8">
      <span className="text-[11px] uppercase tracking-[0.2em] font-bold text-white/40">
        {kicker}
      </span>
      <ul className="mt-6 space-y-5">
        {items.map(({ icon: Icon, title, text }) => (
          <li key={title} className="flex items-start gap-4">
            <span className="flex items-center justify-center w-11 h-11 shrink-0 rounded-xl bg-white/[0.06] border border-white/10">
              <Icon className="w-[18px] h-[18px] text-brand-orange" />
            </span>
            <span>
              <span className="block font-display font-bold text-lg text-white">
                {title}
              </span>
              <span className="block mt-0.5 text-sm leading-relaxed text-white/55">
                {text}
              </span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  </div>
);
